import { render, staticRenderFns } from "./FieldSchemaProperty.vue?vue&type=template&id=753caad1&"
import script from "./FieldSchemaProperty.vue?vue&type=script&lang=js&"
export * from "./FieldSchemaProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports